import { render, staticRenderFns } from "./program-view-pharmacy-orders-delivery-details-weighnow.vue?vue&type=template&id=2ee72c06&scoped=true"
import script from "./program-view-pharmacy-orders-delivery-details-weighnow.vue?vue&type=script&lang=js"
export * from "./program-view-pharmacy-orders-delivery-details-weighnow.vue?vue&type=script&lang=js"
import style0 from "./program-view-pharmacy-orders-delivery-details-weighnow.vue?vue&type=style&index=0&id=2ee72c06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee72c06",
  null
  
)

export default component.exports